var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shop-selection",
    class: {
      'shop-selection--disabled': _vm.computedDisabled
    }
  }, [Object.keys(_vm.candidateBranchModels).length === 0 && false === _vm.shouldDisplayLoading ? _c('SharedSelect', {
    attrs: {
      "value": null,
      "placeholder": "查無資料",
      "hasBorder": false
    }
  }) : Object.keys(_vm.selectedBranchIds).length === 0 && _vm.shouldDisplayLoading ? _c('div', {
    staticClass: "shop-selection__loading-wrapper mb-2"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : [_vm._l(Object.keys(_vm.candidateBranchModels), function (level) {
    return _c('div', {
      key: level,
      staticClass: "mb-2"
    }, [_c('SharedSelect', {
      attrs: {
        "options": _vm.formatBranchModelsToOptions(_vm.candidateBranchModels[level]),
        "placeholder": _vm.placeholder,
        "hasBorder": false,
        "disabled": _vm.shouldDisplayLoading || _vm.disabled
      },
      on: {
        "input": function input($event) {
          return _vm.handleAnyBranchSelected(_vm.selectedBranchIds[level], level);
        }
      },
      model: {
        value: _vm.selectedBranchIds[level],
        callback: function callback($$v) {
          _vm.$set(_vm.selectedBranchIds, level, $$v);
        },
        expression: "selectedBranchIds[level]"
      }
    })], 1);
  }), _vm.shouldDisplayLoading ? _c('div', {
    staticClass: "shop-selection__loading-wrapper mb-2"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "2px"
    }
  })], 1) : _vm._e()]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }